// What the agent did in THIS conversation (agent v2 `actions`, migration 278),
// with Annuler on each album change and Valider / Refuser on a money decision.
// Shown under the order in the conversation view; renders nothing while the
// chat has no action (or the journal does not exist yet).
import { useQuery } from '@tanstack/react-query';
import { whatsappApi } from '@/lib/api';
import { useT } from '@/lib/i18n';
import { AgentActionRow, AGENT_ACTIONS_KEY } from '../AgentActionRow';

export function ChatActionsCard({ chatId }: { chatId: string }) {
  const { t } = useT();
  const { data } = useQuery({
    queryKey: [AGENT_ACTIONS_KEY, 'chat', chatId],
    queryFn: () => whatsappApi.agentActions({ chat: chatId, limit: 20 }),
    refetchInterval: 60_000,
  });
  const items = data?.items ?? [];
  if (!items.length) return null;
  return (
    <section className="mt-3" aria-label={t('Actions de l’agent sur cette conversation')}>
      <h3 className="text-[12px] font-semibold text-gray-700 mb-1.5">{t('Actions de l’agent')}</h3>
      <div className="space-y-1.5">
        {items.map((it) => <AgentActionRow key={it.id} item={it} />)}
      </div>
    </section>
  );
}
